import { ThunkResult } from '../../../store'
import inventoryCaseApi from '../../../apis/inventoryCase.api'
import { replaceResult } from './StandaloneCases.slice'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().standaloneCases
    const params = { page, limit, search }
    inventoryCaseApi.paginateBare(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}
